

const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;

export const createOrder = async (leadId, orderData) => {
    console.log(orderData)
    const token = localStorage.getItem('token');
    console.log(token)
    try {
        const response = await fetch(
            `${API_BASE_URL}/admin/lead/leads/${leadId}/orders`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                body: JSON.stringify(orderData),
            }
        );

        if (!response.ok) {
            const errorData = await response.json();
            console.log(errorData)
            console.error('Ошибка при создании сделки:', errorData);
            throw errorData;
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Ошибка при запросе на создание сделки:', error);
        throw error;
    }
};